import { render, staticRenderFns } from "./serveFour.vue?vue&type=template&id=910faa30&scoped=true"
import script from "./serveFour.vue?vue&type=script&lang=js"
export * from "./serveFour.vue?vue&type=script&lang=js"
import style0 from "./serveFour.vue?vue&type=style&index=0&id=910faa30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910faa30",
  null
  
)

export default component.exports